<template>
  <div>
    <h4 class="text-text-neutral-tertiary text-xs font-medium">{{ title }}</h4>
    <ul class="divide-situational-lightgrey divide-y">
      <li v-for="city in citiesList" :key="city.code">
        <CityCard
          :class="{
            'first:border-situational-lightgrey first:border-b':
              city.children?.length,
          }"
          :iata="city.code"
          :name="city.name"
          :country="city.country.name"
          data-qa-id="citiesList.item"
          @click="emit('onCitySelect', city)"
        />
        <ul
          v-if="city.children?.length && !isChildrenHidden"
          class="divide-situational-lightgrey divide-y"
        >
          <CityCard
            v-for="airport in city.children"
            :key="airport.code"
            :iata="airport.code"
            :name="airport.name"
            :country="airport.country.name"
            @click="emit('onCitySelect', airport)"
          >
            <template #icon><slot /></template>
          </CityCard>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import type { MappedCity, MappedLocation } from 'shared';
  import CityCard from './CityCard.vue';

  defineProps<{
    title: string;
    citiesList: Array<MappedCity>;
    isChildrenHidden?: boolean;
  }>();

  const emit = defineEmits<{ onCitySelect: [city: MappedLocation] }>();
</script>
